export const simulatedCall = (promise) => {
  return new Promise(resolve => {
    setTimeout(resolve, 1500);
  }).then(() => promise);
}